<template>
  <div class="row" id="link-social-accounts">
    <div v-if="loading" class="col-md-6 col-md-offset-3 loading">
      <img src="/wp-content/themes/snappy-theme/assets/images/loading2.gif" />
    </div>
    <div v-else class="col-md-12 integration" :class="{center: onboarding}">
      <div class="row">
        <div v-if="isIntegrated !== false" class="col-md-12 standard-mode">
          <a @click="connect" :class="{linked: isIntegrated}" class="integration-option salesforce">
            <div class="icon fa fa-server"></div>
            Salesforce
            <div v-if="isIntegrated" class="status-icon fas fa-icon fa-check"></div>
            <div class="connection-status">
              <strong>
                {{
                  !onboarding && isIntegrated === true
                    ? 'Your Salesforce account is successfully integrated.'
                    : 'Click here to connect'
                }}
              </strong>
            </div>
          </a>
        </div>
        <div v-if="isIntegrated" class="col-md-12 send-leads-to-salesforce">
          <input
            name="send_leads_to_salesforce"
            type="checkbox"
            class="form-check-input"
            id="send_leads_to_salesforce"
            @change="updateSendNewLeadsToSalesforceSetting"
            v-model="sendNewLeadsToSalesforce"
          />
          <label class="form-check-label" for="send_leads_to_salesforce">&nbsp;Send new leads to SalesForce</label>
        </div>
        <div class="disconnect-container">
          <div v-if="isIntegrated === true" @click="disconnect()" class="disconnect-button">
            Click here to disconnect
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import querystring from 'querystring';
import {showProfileLockedWarning} from '../utility/showProfileLockedWarning';
import {getConnectLink} from './integrations/getConnectLink';

export default {
  name: 'link-salesforce-accounts',
  data() {
    return {
      isIntegrated: null,
      loading: true,
      sendNewLeadsToSalesforce: false,
    };
  },
  props: {
    vesselId: {
      required: true,
      type: String,
    },
    snappyBrain: {
      required: true,
      type: String,
    },
    redirectUrl: {
      required: true,
      type: String,
    },
    onboarding: {
      required: false,
      type: Boolean,
      default: false,
    },
    profileLocked: {
      type: Boolean,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateSendNewLeadsToSalesforceSetting() {
      const isEnabled = document.getElementById('send_leads_to_salesforce').checked;

      axios
        .post('/api/?entity=vessel&action=updateSendNewLeadsToSalesforceSetting', {isEnabled: isEnabled})
        .then(() => {
          if (isEnabled) {
            $.notify('New leads will now be sent to Salesforce!', 'success');
          } else {
            $.notify('New leads will no longer be sent to Salesforce!', 'success');
          }
        });
    },
    disconnect() {
      showProfileLockedWarning.warning(this.profileLocked).then(() => {
        let status = confirm('Are you sure you want to disconnect Salesforce?');

        if (status) {
          axios.post('/api/?entity=vessel&action=disconnectActiveCrm').then(() => {
            $.notify('Salesforce Account Disconnected!', 'success');
            location.reload();
          });
        }
      });
    },
    connect() {
      showProfileLockedWarning.warning(this.profileLocked).then(() => {
        getConnectLink('salesforce', this.redirectUrl);
      });
    },
  },
  mounted() {
    axios
      .get('/api/?entity=vessel&action=getVesselCrms&refreshSession=1')
      .then(response => {
        if (Array.isArray(response.data.crms) && response.data.crms.length) {
          const filtered = response.data.crms.filter(crm => crm.name === 'salesforce');

          if (response.data.push_new_form_submissions_to_salesforce == 1) {
            this.sendNewLeadsToSalesforce = true;
          }

          return filtered[0];
        }
      })
      .then(salesforce => {
        if (!!salesforce) {
          this.isIntegrated = true;
          this.$emit('salesforce-integration-status', true);
        } else {
          this.$emit('salesforce-integration-status', false);
        }
        this.loading = false;
      });
  },
};
</script>

<style lang="scss">
.center {
  width: 270px;
  display: block;
  margin: 0 auto;

  .integration-option {
    width: 100% !important;
  }
}

.row.social {
  position: relative;
}

#link-social-accounts {
  $salesforce: #1798c1;
  $disabled: #cccccc;
  $cancel: #993333;

  .integration {
    .integration-option {
      width: 270px;
      height: 40px;
      line-height: 40px;
      font-size: 26px;
      font-weight: bold;
      color: #fff;
      position: relative;
      margin: 0 0 25px 0;
      transition: ease background 400ms;
      display: block;
      cursor: pointer;
      background: $disabled;

      .icon {
        position: absolute;
        left: 0;
        top: 0;
        width: 40px;
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        color: #fff;
        background: $disabled;
      }

      .status-icon {
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        color: #fff;
      }

      .connection-status {
        position: absolute;
        left: 0;
        bottom: -62px;
        height: 60px;
        color: #777;
        font-size: 12px;
        font-weight: normal;
        line-height: 20px;
        text-align: left;

        .url {
          color: rgba(0, 0, 0, 0.3);
        }
      }
    }

    .standard-mode {
      .salesforce.linked {
        background: lighten($salesforce, 5%);
        float: left;

        .icon,
        .status-icon {
          background: $salesforce;
        }
      }

      .integration-option:hover {
        &.salesforce {
          background: darken($salesforce, 5%);

          .icon {
            background: $salesforce;
          }
        }
      }
    }

    .linked {
      cursor: default;
      pointer-events: none;
    }

    .disconnect-container {
      float: left;
      width: 100%;
      padding: 0 15px;

      .disconnect-button {
        float: left;
        text-align: left;
        color: #777;
        font-size: 12px;
        font-weight: normal;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .send-leads-to-salesforce {
    background: #e8e8e8;
    border: 1px solid #dfdfdf;
    padding: 7px 12px;
    text-align: left;
    max-width: 250px;
    margin: 10px 15px;

    label {
      font-size: 15px;
    }
  }
}

.loading {
  img {
    width: 75px;
  }
}
</style>
